import { createStore } from '@orderx/lab/xr/store';
import { useEffect } from 'react';

const { useStore } = createStore({
    overlaysOpen: 0,
});

export function useHtmlDocument() {
    const [state, setState] = useStore();

    return {
        ...state,

        setIsOverflowHidden(isOverflowHidden: boolean) {
            if (isOverflowHidden) {
                document.documentElement.classList.add('dialog-open');
            } else {
                document.documentElement.classList.remove('dialog-open');
            }
        },

        useRegister() {
            useEffect(() => {
                if (state.overlaysOpen > 0) {
                    document.documentElement.classList.add('dialog-open');
                } else {
                    document.documentElement.classList.remove('dialog-open');
                }
            }, [state.overlaysOpen]);
        },

        useRegisterDialog() {
            useEffect(() => {
                setState((state) => {
                    state.overlaysOpen += 1;
                });

                return () => {
                    setState((state) => {
                        state.overlaysOpen -= 1;
                    });
                };
            }, []);
        },
    };
}
